import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DebtsDtoKeysEnum } from '@zaoblako/shared/modules/debts/enums/debts-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { entityLikeSchema, entityLikeSchemaStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { ContractFindInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';

import * as yup from 'yup';

/** Debt collection task update API request body - DTO signature */
export interface DebtCollectionTaskFormInterface {
  /** Debt collection task id */
  id?: number;
  /** Debt amount */
  amount: number;
  /** The company collecting the debt */
  company: CompanyFindInterface;
  /** The counterparty from whom the debt is collected */
  contragent: ContragentFindInterface;
  /** The contract under which the debt is collected */
  contract: ContractFindInterface;
  /** Deadline for debt collection */
  deadline?: Date;
  /** Responsible user (creator by default) */
  responsible?: UserFindInterface;
  /** Task auditor users */
  userAuditors?: UserFindInterface[];
  /** Task auditor user groups */
  userGroupAuditors?: UserGroupFindInterface[];
}

/** Debt collection task update API request body - DTO schema */
export const DebtCollectionTaskFormDto = SerdeDtoClass.create<DebtCollectionTaskFormInterface>(DebtsDtoKeysEnum.DEBT_COLLECTION_TASK_FORM_DTO, {
  id: {
    optional: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  amount: {
    label: 'Сумма',
    serializer: yup
      .number()
      .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE),
  },
  company: {
    label: 'Компания',
    serializer: entityLikeSchemaStrict,
    checkers: [ClientCheckerKeysEnum.COMPANY_ASSERT_EXISTS_BY_DTO],
  },
  contragent: {
    label: 'Контрагент',
    serializer: entityLikeSchemaStrict,
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
  },
  contract: {
    label: 'Договор',
    serializer: entityLikeSchemaStrict,
  },
  deadline: {
    optional: true,
    label: 'Дедлайн',
    serializer: yup.date(),
  },
  responsible: {
    optional: true,
    label: 'Ответственный',
    serializer: entityLikeSchema,
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
  },
  userAuditors: {
    optional: true,
    label: 'Пользователи-аудиторы',
    serializer: yup.array(entityLikeSchema),
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
  },
  userGroupAuditors: {
    optional: true,
    label: 'Группы-аудиторы',
    serializer: yup.array(entityLikeSchema),
    checkers: [SecurityBackendValidatorsEnum.USER_GROUP_ASSERT_EXISTS_BY_DTO],
  },
});
